import { Deserializable } from "../shared/models/deserializable.model";

import { Business } from "../models/business";
import { User } from "../models/user";
import { Country } from "../models/country";

export class Account implements Deserializable {
   id: number;
   externalId: string;
   name: string;
   users: User[];
   businesses: Business[];
   countryId: number;
   Country: Country;
   currency: string;

   deserialize(input: any) {
   	Object.assign(this, input);
      return this;
   }
}